import axios from "axios";
import { apiHost } from "../../../api/apiClient";

const CACHE_PREFIX = "runSheetCapability:";
const CACHE_DURATION_MS = 5 * 60 * 1000;
const memoryCache = {};

const getCacheKey = (customerId) => `${CACHE_PREFIX}${customerId || "current-customer"}`;

const readCachedCapability = (customerId) => {
  const cacheKey = getCacheKey(customerId);
  const memoryValue = memoryCache[cacheKey];
  if (memoryValue && Date.now() - memoryValue.checkedAt < CACHE_DURATION_MS) {
    return memoryValue.enabled;
  }

  try {
    const storedValue = JSON.parse(window.sessionStorage.getItem(cacheKey));
    if (storedValue && Date.now() - storedValue.checkedAt < CACHE_DURATION_MS) {
      memoryCache[cacheKey] = storedValue;
      return storedValue.enabled;
    }
  } catch (e) {
    // Capability caching is optional; the API remains the source of truth.
  }

  return null;
};

export const cacheRunSheetCapability = (customerId, enabled) => {
  const cacheKey = getCacheKey(customerId);
  const cacheValue = { enabled: !!enabled, checkedAt: Date.now() };
  memoryCache[cacheKey] = cacheValue;

  try {
    window.sessionStorage.setItem(cacheKey, JSON.stringify(cacheValue));
  } catch (e) {
    // Continue with the in-memory cache when session storage is unavailable.
  }
};

export const getRunSheetCapability = async (customerId, headers) => {
  const cachedValue = readCachedCapability(customerId);
  if (cachedValue !== null) {
    return cachedValue;
  }

  const customerQuery = customerId ? `?customerId=${encodeURIComponent(customerId)}` : "";
  const response = await axios.get(`${apiHost}/api/RunSheets/capability${customerQuery}`, { headers });
  const enabled = !!(response.data && response.data.enabled);
  cacheRunSheetCapability(customerId, enabled);
  return enabled;
};
